import { type FC, useState } from "react";
import { useScroll, useMotionValueEvent } from "framer-motion";
import { Banner } from "@tennr/frontend/components/Banner";
import { Navigation, type NavigationItem } from "@tennr/frontend/components/Navigation";
import "./SiteHeader.css";

export const SiteHeader: FC = () => {
  const [hideBanner, setHideBanner] = useState(false);
  const { scrollY } = useScroll();

  // const banner = null
  const banner = {
    content: "We just raised a $101M Series C to bring visibility to the patient journey.",
    to: "https://fortune.com/2025/06/18/tennr-health-tech-ai-patient-referral-ivp-a16z-lightspeed-iconiq-series-c/",
    newTab: true,
  };

  const navigationItems: NavigationItem[] = [
    {
      title: "Product",
      to: "/product",
    },
    {
      title: "Company",
      subitems: [
        {
          title: "About Us",
          to: "/about",
        },
        {
          title: "Careers",
          to: "/careers",
        },
      ],
    },
    {
      title: "Resources",
      to: "/resources",
    },
    {
      title: "Customer Stories",
      to: "/customer-stories",
    },
  ];

  useMotionValueEvent(scrollY, "change", (y) => {
    if (banner) setHideBanner(y >= 50);
  });

  return (
    <header className={`site-header ${hideBanner ? "hide-banner" : ""}`}>
      {banner ? <Banner content={banner.content} newTab={banner.newTab} to={banner.to} /> : undefined}
      <Navigation navigationItems={navigationItems} />
    </header>
  );
};
